<template>
  <nav class="manager-pagination" aria-label="列表分页">
    <span>共 {{ total }} {{ unit }}，第 {{ page + 1 }} / {{ Math.max(pages, 1) }} 页</span>
    <div class="page-actions">
      <button type="button" :disabled="disabled || page === 0" @click="$emit('change', 0)">首页</button>
      <button type="button" :disabled="disabled || page === 0" @click="$emit('change', page - 1)">{{ byDate ? '上一日期' : '上一页' }}</button>
      <button type="button" :disabled="disabled || page + 1 >= pages" @click="$emit('change', page + 1)">{{ byDate ? '下一日期' : '下一页' }}</button>
      <button type="button" :disabled="disabled || page + 1 >= pages" @click="$emit('change', pages - 1)">末页</button>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'ManagerPagination',
  props: { page: Number, pages: Number, total: Number, disabled: Boolean, byDate: Boolean, unit: { type: String, default: '条' } }
}
</script>

<style scoped>
.manager-pagination { display:flex; flex:none; align-items:center; justify-content:flex-end; flex-wrap:wrap; gap:10px 16px; margin-top:16px; color:#728789; font-size:12px; }
.page-actions { display:flex; gap:8px; }
.page-actions button { height:32px; padding:0 10px; border:1px solid #d6e1de; border-radius:5px; color:#496467; background:#fff; cursor:pointer; font:inherit; white-space:nowrap; }
.page-actions button:disabled { opacity:.45; cursor:default; }
@media (max-width:640px) { .manager-pagination { justify-content:space-between; margin-top:12px; } .page-actions { gap:6px; } }
</style>
